var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-item secondary" },
      [
        _c(
          "b-collapse",
          {
            attrs: { open: false },
            scopedSlots: _vm._u([
              {
                key: "trigger",
                fn: function (props) {
                  return [
                    _c(
                      "b-switch",
                      {
                        attrs: {
                          id: "type-switch",
                          "aria-expanded": props.open,
                        },
                        model: {
                          value: _vm.isSwitched,
                          callback: function ($$v) {
                            _vm.isSwitched = $$v
                          },
                          expression: "isSwitched",
                        },
                      },
                      [
                        _c("h5", { staticClass: "is-size-5" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("transactions.createWalletEntryTitle")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _c("br"),
            _c("div", { staticClass: "content" }, [
              _c("div", { attrs: { id: "modifier-items" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-select",
                      {
                        attrs: { id: "type-select", size: "is-small" },
                        model: {
                          value: _vm.selectedOption,
                          callback: function ($$v) {
                            _vm.selectedOption = $$v
                          },
                          expression: "selectedOption",
                        },
                      },
                      [
                        _c("option", { attrs: { value: "condone" } }, [
                          _vm._v("Perdonazo"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("generalWords.Amount")) +
                          " (" +
                          _vm._s(_vm.$t("currency.symbol")) +
                          "): "
                      ),
                    ]),
                    _c("b-input", {
                      staticClass: "text",
                      attrs: {
                        id: "confirm-input",
                        size: "is-small",
                        type: "number",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          return _vm.validateInputs.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.amountField,
                        callback: function ($$v) {
                          _vm.amountField = $$v
                        },
                        expression: "amountField",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        class: `is-button-primary ${
                          _vm.isLoading ? "is-loading" : ""
                        }`,
                        attrs: {
                          id: "confirm-button",
                          disabled: !_vm.checkUserFeature(
                            "element.transaction-approval.button.confirm-payment"
                          ),
                          rounded: "",
                          size: "is-small",
                        },
                        on: { click: _vm.createWalletEntry },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("transactions.addWalletEntry")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.errorMessage
                ? _c("div", [
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }